import { Link, Stack, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"

export function MaintenanceTaskElementSelectorBreadcrumbItem({ item, index }) {
    const { onBreadcrumbNavigate } = useBoundContext()
    const isDirectory = item?.type === "directory"

    return (
        <Stack direction="row" spacing={0.5} alignItems="center">
            <Typography variant="caption" color="text.disabled">
                ›
            </Typography>
            <Iconify
                icon={isDirectory ? "mdi:folder-outline" : "mdi:file-document-outline"}
                width={14}
                sx={{ color: isDirectory ? "warning.main" : "text.secondary", flexShrink: 0 }}
            />
            <Link
                data-cy="maintenance-selector-breadcrumb"
                component="button"
                variant="caption"
                underline="hover"
                color="text.secondary"
                onClick={handleClick}
                sx={{ cursor: "pointer" }}
            >
                {item.name}
            </Link>
        </Stack>
    )

    function handleClick() {
        onBreadcrumbNavigate(index)
    }
}
